import React, { memo } from 'react';
import Media from 'react-media';
import styled from 'styled-components';
import { COLORS, MQS, SPACINGS, SIZES } from '../app/common/constants/styles';
import Logo from '../app/common/logos/RakutenLogo';
import { addRatEvent } from '../utils/ratClickEvents';
import { SigninButton, SignupButton, SigninButtonMobile } from './components';

const Base = styled.header`
    height: 60px;
    background-color: ${COLORS.white};
`;

const HeaderWrapper = styled.div`
    align-items: center;
    display: flex;
    height: 100%;
    margin: auto;
    padding: 0px 20px;
    max-width: ${1.1 * SIZES.appMaxWidth}px;
    position: relative;

    @media (max-width: ${MQS.mq2Min}) {
        padding: 0px ${SPACINGS.base * 2}px;
    }
`;

const HeaderLeft = styled.div`
    bottom: 0;
    height: 37px;
    margin: auto;
    position: absolute;
    top: 0;
`;

const HeaderSpacer = styled.div`
    flex: 1 1 0px;
`;

const HeaderRight = styled.div`
    align-items: center;
    display: flex;
`;

const LogoWrapper = styled.div`
    height: 100%;
    width: 120px;

    a {
        cursor: pointer;
        display: block;
        height: 100%;
    }
`;

const Header = (props: any) => {
    return (
        <Base>
            <HeaderWrapper>
                <HeaderLeft>
                    <LogoWrapper>
                        <a
                            href={'/about'}
                            rel="noopener noreferrer"
                            onClick={() => addRatEvent('about', 'header_logo')}
                        >
                            <Logo />
                        </a>
                    </LogoWrapper>
                </HeaderLeft>
                <HeaderSpacer />
                {window.location.pathname === '/about' && (
                    <HeaderRight>
                        <Media
                            query={`(max-width: ${MQS.mq2Max})`}
                            render={() => (
                                <React.Fragment>
                                    <SigninButtonMobile appConfig={props.appConfig} />
                                </React.Fragment>
                            )}
                        />
                        <Media
                            query={`(min-width: ${MQS.mq3Min})`}
                            render={() => (
                                <React.Fragment>
                                    <SigninButton appConfig={props.appConfig} margin={true} />
                                    <SignupButton appConfig={props.appConfig} />
                                </React.Fragment>
                            )}
                        />
                    </HeaderRight>
                )}
            </HeaderWrapper>
        </Base>
    );
};

export default memo(Header);
